/**
 * Gets poynt API URL
 * @param {string} env
 * @returns
 */
export function getAPIUrl(env) {
  switch (env) {
    case "development":
      return "http://local.poynt.net";
    case "dev-private":
      return "https://ci.poynt.net";
    case "ci":
      return "https://ci.poynt.net";
    case "test":
      return "https://test.poynt.net";
    case "ote":
      return "https://ote.poynt.net";
    default:
      return "https://poynt.net";
  }
}

/**
 * Gets poynt collect URL
 * @param {string} env
 * @returns
 */
export function getCollectUrl(env) {
  switch (env) {
    case "development":
      return "https://collect.commerce.dev-godaddy.com/sdk.js";
      return "https://local.collect.commerce.dev-godaddy.com/sdk.js";
    case "dev-private":
      return "https://collect.commerce.dev-godaddy.com/sdk.js";
    case "ci":
      return "https://collect.commerce.dev-godaddy.com/sdk.js";
    case "st":
      return "https://collect.commerce.test-godaddy.com/sdk.js";
    case "ote":
      return "https://collect.commerce.ote-godaddy.com/sdk.js";
    case "test":
      return "https://collect.commerce.test-godaddy.com/sdk.js";
    default:
      return "https://collect.commerce.godaddy.com/sdk.js";
  }
}

/**
 * Gets VT URL
 * @param {string} env
 * @returns
 */
export function getVTUrl(env) {
  switch (env) {
    case "development":
      // return "https://vt-ci.poynt.net";
      return "http://vt.local.poynt.net";
    case "dev-private":
      return "https://vt-ci.poynt.net";
    case "ci":
      return "https://vt-ci.poynt.net";
    case "st":
      return "https://vt-test.poynt.net";
    case "ote":
      return "https://vt-ote.poynt.net";
    case "test":
      return "https://vt-test.poynt.net";
    default:
      return "https://vt.poynt.net";
  }
}

/**
 * Gets MBE URL
 * @param {string} env
 * @returns
 */
export function getPaylinksMbeUrl(env) {
  switch (env) {
    case "development":
      // (unsure here) return "https://commsplat-cx-mbe-paylinks-dev-private.commsplat-dev-private.prod.onkatana.net";
      return "https://paylinks.mbe.commerce.dev-godaddy.com";
    case "dev-private":
      return "https://paylinks.mbe.commerce.dev-godaddy.com";
    case "ci":
      return "https://paylinks.mbe.commerce.dev-godaddy.com";
    case "st":
      return "https://paylinks.mbe.commerce.test-godaddy.com";
    case "ote":
      return "https://paylinks.mbe.commerce.test-godaddy.com";
    case "test":
      return "https://paylinks.mbe.commerce.test-godaddy.com";
    default:
      return "https://paylinks.mbe.commerce.godaddy.com";
  }
}
